import React, {useEffect, useState} from "react";
import {Alert, Stack} from "react-bootstrap"
import pkg from "../../package.json"
import { wrappedGet } from "../utilities/AxiosHelper";
import DOMPurify from "dompurify";

export default function VersionCheck() {
    const [showVersionAlert, setShowVersionAlert] = useState(false);
    const [versionMessage, setVersionMessage] = useState("");

    useEffect(() => {
        checkAppVersion();
    }, []);

    const isServerVersionNewer = (serverNumber, appNumber) => {
        /**
         * Compares two semantic version strings (e.g., "1.0.0", "1.0.1", "2.0.0").
         * @param {string} v1 The first version string.
         * @param {string} v2 The second version string.
         * @returns {number}
         *  -1 if v1 < v2
         *   0 if v1 = v2
         *   1 if v1 > v2
         */
        const result = String(serverNumber).localeCompare(String(appNumber), undefined, {
            numeric: true,
            sensitivity: "base",
        });
        if (result === 1) {
            return true;
        } else {
            return false;
        }
    };

    const checkAppVersion = async () => {
        try {
            if (typeof pkg?.version === "undefined") {
                // fail gracefully if we dont have an app version number
                return;
            }
            const appVersionLookup = await wrappedGet('/application-version');
            const serverData = appVersionLookup.data;
            const serverVersion = serverData?.release_version ?? "";
            const appVersion = pkg.version;
            // if we get here we need to verify the app version value exists and is valid
            const validateServerVersion = /^\d+\.\d+\.\d+$/.test(serverVersion);
            const validateAppVersion = /^\d+\.\d+\.\d+$/.test(appVersion);
            if (!validateServerVersion || !validateAppVersion) {
                // we don't have valid number so fail gracefully
                return;
            }

            if (isServerVersionNewer(serverVersion, appVersion)) {
                const msg = `OARS Version <strong>${serverVersion}</strong> is available. You are currently 
                    running version <strong>${appVersion}</strong>. Please save your work and refresh your browser.`;
                setVersionMessage(DOMPurify.sanitize(msg));
                setShowVersionAlert(true);
            }
        } catch (error) {
            console.error(error)
        }
    };

    return (
        <div>
            {showVersionAlert && (
                <Alert key="version_check_alert" className="mb-0" variant="warning" role="alert" aria-live="polite">
                    <Stack direction="horizontal" gap={6} className="align-items-center">
                        <i className="bi bi-check-circle-fill text-warning fs-2" />
                        <div dangerouslySetInnerHTML={{__html: versionMessage}} />
                    </Stack>
                </Alert>
            )}
        </div>
    );
}
